import React, { useState, createContext } from "react";
import { useLocation } from "react-router-dom";
export const ThankyouContext = createContext({});
export const ThankyouContextProvider = ({ children }) => {
  const location=useLocation();
  const thankyouMessage = location?.state;

  const providerValue = {
    thankyouMessage
  };
  return (
    <ThankyouContext.Provider value={providerValue}>{children}</ThankyouContext.Provider>
  );
};
